module.exports = __webpack_public_path__ + "static/media/csv.91f83b3b.png";